// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b4t1","col":"styles_col__3m3ij"};